import * as React from 'react';
import { styled } from '@glitz/react';
import { Block, desktopEdgeMarginDecorator, contentWidthDecorator } from 'webapp/components/page-layout';
import {
  addSelectRetailMediaBannerToDataLayer,
  addViewRetailMediaBannerToDataLayer,
  useRetailMediaViewEventTrigger,
} from 'webapp/tracking/events/retail-media';

type PropType = {
  banner?: NordicNest.Api.RetailMediaBanner;
};

export default function RetailMediaBannerAd(props: PropType) {
  const self = React.useRef<HTMLDivElement>(null);
  useRetailMediaViewEventTrigger(self, addViewRetailMediaBannerToDataLayer, {
    adId: props?.banner?.adId,
  });

  if (!props.banner) {
    return null;
  }

  return (
    <Base ref={self}>
      <a
        href={props.banner?.linkUrl}
        id={props.banner?.adId}
        onClick={() => {
          addSelectRetailMediaBannerToDataLayer(props.banner?.adId);
        }}
      >
        <BannerImage src={props.banner?.imageUrl} alt={props.banner?.altText} />
      </a>
    </Base>
  );
}

const Base = styled(Block, desktopEdgeMarginDecorator, contentWidthDecorator('normal'), {
  position: 'relative',
  overflow: 'hidden',
  maxWidth: '100%',
});

const BannerImage = styled.img({
  width: '100%',
});
